import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VCard, VSimpleTable, VCheckbox } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosListDemo',
    setup(__props) {
        const selected = ref([1]);
        const switchVal = ref(true);
        const avatarUrl = 'https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light';
        const items = [
            { text: 'Opción 1', value: 1 },
            { text: 'Opción 2', value: 2 },
            { text: 'Opción 3', value: 3 },
        ];
        const listProps = [
            { name: 'density', type: 'string', default: 'undefined', desc: 'Densidad: "default", "comfortable", "compact".' },
            { name: 'selectable', type: 'boolean', default: 'false', desc: 'Habilita la funcionalidad de selección (v-list-item-group).' },
            { name: 'multiple', type: 'boolean', default: 'false', desc: 'Permite seleccionar múltiples elementos.' },
            { name: 'value', type: 'any', default: 'null', desc: 'Modelo para la selección (v-model).' },
            { name: 'variant', type: 'string', default: 'undefined', desc: 'Variante de estilo visual.' },
            { name: 'activeClass', type: 'string', default: "'beos-item--active'", desc: 'Clase CSS aplicada al elemento seleccionado.' },
        ];
        const itemProps = [
            { name: 'title', type: 'string', default: 'undefined', desc: 'Título principal del elemento.' },
            { name: 'subtitle', type: 'string', default: 'undefined', desc: 'Texto secundario.' },
            { name: 'prepend-icon', type: 'string', default: 'undefined', desc: 'Icono a la izquierda.' },
            { name: 'append-icon', type: 'string', default: 'undefined', desc: 'Icono a la derecha.' },
            { name: 'prepend-avatar', type: 'string', default: 'undefined', desc: 'URL de imagen a la izquierda.' },
            { name: 'append-avatar', type: 'string', default: 'undefined', desc: 'URL de imagen a la derecha.' },
            { name: 'density', type: 'string', default: 'undefined', desc: 'Densidad específica del item.' },
            { name: 'variant', type: 'string', default: 'undefined', desc: 'Variante específica del item.' },
        ];
        return { __sfc: true, selected, switchVal, avatarUrl, items, listProps, itemProps, VContainer, VRow, VCol, VCard, VSimpleTable, VCheckbox, CodePreview, DemoSection };
    }
});
